import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { SubSink } from 'subsink';
import { UserConfigService } from '../services/user-config.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionPageGuard implements CanActivate, OnDestroy {
  subs = new SubSink();
  constructor(private router: Router, private userConfigService: UserConfigService) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const routePermissions = route.data.permissions as string[];
    let isAuth: boolean = false;

    if (routePermissions) {
      this.subs.sink = this.userConfigService.isAuthorized(routePermissions).subscribe(
        data => {
          isAuth = data;
          if (!isAuth) {
            this.router.navigate(['/access-denied']);
          } else {
            if (!state.url.startsWith('/ledger')) {
              localStorage.setItem('Etech.IntegratedInvoicingWeb_redirectUrl', state.url);
            }
          }
        },
        (err: HttpErrorResponse) => {
          isAuth = false;
        },
      );
    } else {
      this.router.navigate(['/access-denied'], { skipLocationChange: true });
      return of(false);
    }

    return of(isAuth);
  }
}
